import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "../lib/lenis";
import { fadeUp, stagger, viewport } from "../motion";
import { IMAGES } from "../data";

const steps = [
  { number: "01", title: "Descobrir", text: "Entendemos seu momento, seus desafios e onde está o maior potencial de crescimento." },
  { number: "02", title: "Estratégia", text: "Transformamos dados e contexto em um plano claro, sem complicação e sem achismo." },
  { number: "03", title: "Acelerar", text: "Executamos, medimos e otimizamos até encontrar o que faz seu negócio voar." },
];

export const Method = () => (
  <section className="method" id="method" data-testid="method-section">
    <div className="method-accent" />
    <div className="method-inner">
      <motion.div className="method-copy" initial="hidden" whileInView="show" viewport={viewport} variants={stagger}>
        <motion.p className="eyebrow" variants={fadeUp}><span className="eyebrow-dot" /> Nosso método</motion.p>
        <motion.h2 variants={fadeUp}>Menos achismo.<br /><em>Mais clareza.</em></motion.h2>
        <motion.p variants={fadeUp}>Um processo direto, colaborativo e orientado por aquilo que realmente importa: resultado.</motion.p>
        <motion.div variants={fadeUp}>
          <button className="btn-ghost" onClick={() => scrollToId("contact")} data-testid="method-cta">Vamos conversar <ArrowUpRight size={16} /></button>
        </motion.div>
        <motion.div className="method-media" variants={fadeUp}>
          <img src={IMAGES.office} alt="Escritório da Vanguard em operação" />
        </motion.div>
      </motion.div>
      <motion.div className="steps" initial="hidden" whileInView="show" viewport={viewport} variants={stagger}>
        {steps.map((step) => (
          <motion.div className="step" key={step.number} variants={fadeUp} data-testid={`method-step-${step.number}`}>
            <span className="step-num">{step.number}</span>
            <div><h3>{step.title}</h3><p>{step.text}</p></div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
